<template>
    <div class="booker-container" :class="{ 'booker-scrolled': isScrolledUI }">
        <div class="row justify-content-between align-items-center g-2">

            <!-- AÑO -->
            <div class="col-12 col-md-2">
                <div class="select w-100">
                    <div class="custom-select-wrapper" :class="{ 'select-scrolled': isScrolledUI }">
                        <div class="custom-select-input" @click="toggleDropdownAnio">
                            {{ selectedYear || 'Año' }}
                            <span class="custom-select-arrow" :class="{ 'arrow-scrolled': isScrolledUI }">▼</span>
                        </div>

                        <ul v-if="isOpenAnio" class="custom-select-dropdown"
                            :class="{ 'dropdown-scrolled': isScrolledUI }">
                            <li v-for="year in years" :key="year" @click="selectYear(year)">
                                {{ year }}
                            </li>
                        </ul>
                    </div>

                    <div v-if="isLoading" class="d-flex justify-content-center align-items-center loading-overlay">
                        <div class="spinner-border" role="status" style="color:#06283c">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- MARCA -->
            <div class="col-12 col-md-2">
                <div class="select w-100">
                    <div class="custom-select-wrapper" :class="{ 'select-scrolled': isScrolledUI }">
                        <div class="custom-select-input" @click="toggleDropdownMarca"
                            :class="{ 'disabled-select': isLoadingMarcas || years.length === 0 }">
                            {{ selectedMarca === 0 ? 'Marca' : selectedMarca }}
                            <span class="custom-select-arrow" :class="{ 'arrow-scrolled': isScrolledUI }">▼</span>
                        </div>

                        <ul v-if="isOpenMarca" class="custom-select-dropdown"
                            :class="{ 'dropdown-scrolled': isScrolledUI }">
                            <li v-for="marca in marcas" :key="marca" @click="selectMarca(marca)">
                                {{ marca }}
                            </li>
                        </ul>
                    </div>

                    <div v-if="isLoadingMarcas"
                        class="d-flex justify-content-center align-items-center loading-overlay">
                        <div class="spinner-border" role="status" style="color:#06283c">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- MODELO -->
            <div class="col-12 col-md-2">
                <div class="select w-100">
                    <div class="custom-select-wrapper" :class="{ 'select-scrolled': isScrolledUI }">
                        <div class="custom-select-input" @click="toggleDropdownModelo"
                            :class="{ 'disabled-select': isLoadingModelo || modelos.length === 0 || selectedMarca === 0 }">
                            {{ selectedModelo === 0 ? 'Modelo' : selectedModelo }}
                            <span class="custom-select-arrow" :class="{ 'arrow-scrolled': isScrolledUI }">▼</span>
                        </div>

                        <ul v-if="isOpenModelo" class="custom-select-dropdown"
                            :class="{ 'dropdown-scrolled': isScrolledUI }">
                            <li v-for="modelo in modelos" :key="modelo" @click="selectModelo(modelo)">
                                {{ modelo }}
                            </li>
                        </ul>
                    </div>

                    <div v-if="isLoadingModelo"
                        class="d-flex justify-content-center align-items-center loading-overlay">
                        <div class="spinner-border" role="status" style="color:#06283c">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- MOTOR -->
            <div class="col-12 col-md-2">
                <div class="select w-100">
                    <div class="custom-select-wrapper" :class="{ 'select-scrolled': isScrolledUI }">
                        <div class="custom-select-input" @click="toggleDropdownMotor"
                            :class="{ 'disabled-select': isLoadingMotor || motores.length === 0 || selectedModelo === 0 }">
                            {{ selectedMotor === 0 ? 'Motor' : selectedMotor }}
                            <span class="custom-select-arrow" :class="{ 'arrow-scrolled': isScrolledUI }">▼</span>
                        </div>

                        <ul v-if="isOpenMotor" class="custom-select-dropdown"
                            :class="{ 'dropdown-scrolled': isScrolledUI }">
                            <li v-for="motor in motores" :key="motor" @click="selectMotor(motor)">
                                {{ motor }}
                            </li>
                        </ul>
                    </div>

                    <div v-if="isLoadingMotor" class="d-flex justify-content-center align-items-center loading-overlay">
                        <div class="spinner-border" role="status" style="color:#06283c">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- LÍNEA -->
            <div class="col-12 col-md-2">
                <div class="select w-100">
                    <div class="custom-select-wrapper" :class="{ 'select-scrolled': isScrolledUI }">
                        <div class="custom-select-input" @click="toggleDropdownLinea"
                            :class="{ 'disabled-select': isLoadingLineas || lineas.length === 0 || selectedModelo === 0 }">
                            {{ selectedLineaName || 'Línea' }}
                            <span class="custom-select-arrow" :class="{ 'arrow-scrolled': isScrolledUI }">▼</span>
                        </div>

                        <ul v-if="isOpenLinea" class="custom-select-dropdown"
                            :class="{ 'dropdown-scrolled': isScrolledUI }">
                            <li v-for="linea in lineas" :key="linea.id" @click="selectLinea(linea)">
                                {{ linea.name }}
                            </li>
                        </ul>
                    </div>

                    <div v-if="isLoadingLineas"
                        class="d-flex justify-content-center align-items-center loading-overlay">
                        <div class="spinner-border" role="status" style="color:#06283c">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- BOTÓN -->
            <div class="col-12 col-md-auto">
                <button class="btn btn-success-custom btn-sm" :disabled="isSearchDisabled" @click="buscar"
                    :class="{ 'btn-scrolled': isScrolledUI }">
                    Buscar
                </button>
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        isLargeScreen: { type: Boolean, required: true },
        scrolled: { type: Boolean, required: true },
        isHome: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            isLoggedin: window.Laravel.isLoggedin,
            selectedYear: null,
            selectedMarca: 0,
            selectedModelo: 0,
            selectedMotor: 0,
            selectedLinea: 0,
            selectedLineaName: 'Línea', // Para mostrar el nombre en el custom select
            isLoading: false,
            isLoadingMarcas: false,
            isLoadingModelo: false,
            isLoadingMotor: false,
            isLoadingLineas: false,

            years: [],
            marcas: [],
            modelos: [],
            motores: [],
            lineas: [],
            busqueda: [],

            // Estado para todos los selectores customizados
            isOpenAnio: false,
            isOpenMarca: false,
            isOpenModelo: false,
            isOpenMotor: false,
            isOpenLinea: false,
        };
    },
    methods: {
        // --- MÉTODOS DEL SELECTOR CUSTOMIZADO: AÑO ---
        toggleDropdownAnio() {
            this.closeAllDropdowns('isOpenAnio');
            this.isOpenAnio = !this.isOpenAnio;
        },
        selectYear(year) {
            this.selectedYear = year;
            this.isOpenAnio = false;
            this.handleYearChange();
        },

        // --- MÉTODOS DEL SELECTOR CUSTOMIZADO: MARCA ---
        toggleDropdownMarca() {
            this.closeAllDropdowns('isOpenMarca');
            this.isOpenMarca = !this.isOpenMarca;
        },
        selectMarca(marca) {
            this.selectedMarca = marca;
            this.isOpenMarca = false;
            this.handleMarcaChange();
        },

        // --- MÉTODOS DEL SELECTOR CUSTOMIZADO: MODELO ---
        toggleDropdownModelo() {
            // Solo abrir si hay una marca seleccionada y no está cargando
            if (this.selectedMarca !== 0 && !this.isLoadingModelo) {
                this.closeAllDropdowns('isOpenModelo');
                this.isOpenModelo = !this.isOpenModelo;
            }
        },
        selectModelo(modelo) {
            this.selectedModelo = modelo;
            this.isOpenModelo = false;
            this.handleModeloChange();
        },

        // --- MÉTODOS DEL SELECTOR CUSTOMIZADO: MOTOR ---
        toggleDropdownMotor() {
            // Solo abrir si hay un modelo seleccionado y no está cargando
            if (this.selectedModelo !== 0 && !this.isLoadingMotor) {
                this.closeAllDropdowns('isOpenMotor');
                this.isOpenMotor = !this.isOpenMotor;
            }
        },
        selectMotor(motor) {
            this.selectedMotor = motor;
            this.selectedLinea = 0; // Resetear Línea si se selecciona Motor
            this.selectedLineaName = null;
            this.isOpenMotor = false;
            this.handleMotoresLineasChange();
        },

        // --- MÉTODOS DEL SELECTOR CUSTOMIZADO: LÍNEA ---
        toggleDropdownLinea() {
            // Solo abrir si hay un modelo seleccionado y no está cargando
            if (this.selectedModelo !== 0 && !this.isLoadingLineas) {
                this.closeAllDropdowns('isOpenLinea');
                this.isOpenLinea = !this.isOpenLinea;
            }
        },
        selectLinea(linea) {
            this.selectedLinea = linea.id;
            this.selectedLineaName = linea.name; // Guardar el nombre para mostrarlo
            this.selectedMotor = 0; // Resetear Motor si se selecciona Línea
            this.isOpenLinea = false;
            this.handleMotoresLineasChange();
        },

        // --- UTILIDAD: Cierra todos los desplegables excepto uno ---
        closeAllDropdowns(except) {
            const dropdowns = ['isOpenAnio', 'isOpenMarca', 'isOpenModelo', 'isOpenMotor', 'isOpenLinea'];
            dropdowns.forEach(key => {
                if (key !== except) {
                    this[key] = false;
                }
            });
        },

        // --- LÓGICA DE MANEJO DE CAMBIOS (RESET DE DATOS) ---
        handleYearChange() {
            this.selectedMarca = 0;
            this.selectedModelo = 0;
            this.selectedMotor = 0;
            this.selectedLinea = 0;
            this.selectedLineaName = null;
            this.modelos = [];
            this.motores = [];
            this.lineas = [];
            if (this.selectedYear !== null) {
                this.loadMarcas();
            }
        },
        handleMarcaChange() {
            this.selectedModelo = 0;
            this.selectedMotor = 0;
            this.selectedLinea = 0;
            this.selectedLineaName = null;
            this.modelos = [];
            this.motores = [];
            this.lineas = [];
            if (this.selectedMarca !== 0) {
                this.loadModelos();
            }
        },
        handleModeloChange() {
            this.selectedMotor = 0;
            this.selectedLinea = 0;
            this.selectedLineaName = null;
            this.motores = [];
            this.lineas = [];
            this.loadMotores(); // Esta función ahora cargará tanto motores como líneas
        },
        handleMotoresLineasChange() {
            // Lógica para recargar el campo complementario si solo se selecciona Motor o Línea
            if ((this.selectedMotor !== 0 && this.selectedLinea === 0) ||
                (this.selectedMotor === 0 && this.selectedLinea !== 0)) {

                this.loadMotoresLineas();
            }
        },

        // --- Funciones de Carga (AXIOS COMPLETAS) ---
        loadMarcas() {
            // ... (función loadMarcas sin cambios) ...
            this.isLoadingMarcas = true;
            axios.post(`/catalogo/loadmarcasnuevo`, { year: this.selectedYear })
                .then((response) => {
                    this.marcas = response.data.marcas || [];
                })
                .catch((error) => console.log(error))
                .finally(() => {
                    this.isLoadingMarcas = false;
                });
        },
        loadModelos() {
            // ... (función loadModelos sin cambios) ...
            this.isLoadingModelo = true;
            axios.post(`/catalogo/loadmodelosnuevo`, {
                year: this.selectedYear,
                marca: this.selectedMarca
            })
                .then((response) => {
                    this.modelos = response.data.modelos || [];
                    this.lineas = response.data.lineas || [];
                })
                .catch((error) => console.log(error))
                .finally(() => {
                    this.isLoadingModelo = false;
                });
        },
        loadMotores() {
            // ... (función loadMotores sin cambios) ...
            this.isLoadingMotor = true;
            this.isLoadingLineas = true; // Activar ambos loaders
            axios.post(`/catalogo/loadmotoresnuevo`, {
                year: this.selectedYear,
                marca: this.selectedMarca,
                modelo: this.selectedModelo
            })
                .then((response) => {
                    this.motores = response.data.motores || [];
                    this.lineas = response.data.lineas || [];
                })
                .catch((error) => console.log(error))
                .finally(() => {
                    this.isLoadingMotor = false;
                    this.isLoadingLineas = false;
                });
        },
        loadMotoresLineas() {
            // ... (función loadMotoresLineas sin cambios sustanciales, solo se usa en handleMotoresLineasChange) ...
            this.isLoadingMotor = this.selectedMotor === 0;
            this.isLoadingLineas = this.selectedLinea === 0;

            axios.post(`/catalogo/loadmotoreslineasnuevo`, {
                year: this.selectedYear,
                marca: this.selectedMarca,
                modelo: this.selectedModelo,
                motor: this.selectedMotor,
                linea: this.selectedLinea
            })
                .then((response) => {
                    if (this.selectedMotor === 0 && this.selectedLinea !== 0)
                        this.motores = response.data.motores || [];

                    if (this.selectedMotor !== 0 && this.selectedLinea === 0)
                        this.lineas = response.data.lineas || [];
                })
                .catch((error) => console.log(error))
                .finally(() => {
                    this.isLoadingMotor = false;
                    this.isLoadingLineas = false;
                });
        },

        // --- MÉTODOS DE BÚSQUEDA (SIN CAMBIOS) ---
        buscar() {
            this.$store.dispatch('resetBusquedaAvanzada');
            this.$emit('cerrar-offcanvas');
            this.$router.push({
                name: 'Resultados',
                query: {
                    year: this.selectedYear,
                    marca: this.selectedMarca,
                    modelo: this.selectedModelo,
                    motor: this.selectedMotor || 0,
                    linea: this.selectedLinea || 0,
                    idBusqueda: 0,
                    tipobusqueda: 0,
                    activoUsuario: 0,
                }
            });
        },
        buscar2(busqueda) {
            this.$store.dispatch('resetBusquedaAvanzada');
            this.$router.push({
                name: 'Resultados',
                query: {
                    year: busqueda.anio,
                    marca: busqueda.marca,
                    modelo: busqueda.modelo,
                    motor: busqueda.motor || 0,
                    linea: busqueda.idlinea || 0,
                    idBusqueda: busqueda.id,
                    tipobusqueda: 1,
                    activoUsuario: 1
                }
            });
        }
    },
    mounted() {
        this.isLoading = true;
        axios.get(`/catalogo/catalogocompletemountedNuevo`)
            .then((response) => {
                this.years = response.data.anios || [];
                this.marcas = response.data.marcas || [];
                this.busqueda = response.data.busqueda || [];
                if (this.years.length) {
                    this.selectedYear = this.years[0];
                    this.loadMarcas();
                }
            })
            .catch((error) => console.error(error))
            .finally(() => {
                this.isLoading = false;
            });
    },
    computed: {
        isSearchDisabled() {
            // La búsqueda requiere Año, Marca y Modelo seleccionados
            return !this.selectedYear || this.selectedMarca === 0 || this.selectedModelo === 0;
        },
        isScrolledUI() {
            return this.isHome
                ? (this.isLargeScreen && this.scrolled)
                : true;
        }
    },
};
</script>

<style scoped>
/* ================================================= */
/* 1. ESTADO POR DEFECTO (Header Transparente) */
/* ================================================= */

.booker-container {
    background-color: transparent;
    transition: all 0.2s ease-in-out;
    padding: 10px 15px;
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.select {
    position: relative;
    display: flex;
    width: 100%;
    height: 40px;
    border-radius: 5px;
    overflow: visible;
}

.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    border-radius: 5px;
}

/* --- ESTILOS SELECTORES NATIVOS (<select>) --- */
.select select {
    appearance: none;
    outline: none;
    border: 1px solid #ccc;
    background-color: transparent;
    color: #000;
    height: 40px;
    padding: 5px 10px;
    border-radius: 5px;
    width: 100%;
}

.select::after {
    content: '▼' !important;
    color: #fff;
    position: absolute;
    right: 10px;
    top: 10px;
    pointer-events: none;
    transition: 0.25s all ease;
    z-index: 2;
    font-size: 12px;
}

/* --- ESTILOS DEL SELECTOR CUSTOMIZADO (AÑO) --- */

.custom-select-wrapper {
    position: relative;
    width: 100%;
    height: 40px;
    border-radius: 5px;
    color: white;
    background-color: transparent;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
}

.custom-select-input {
    padding: 5px 10px;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 12px;
    justify-content: space-between;
}

.custom-select-arrow {
    transition: color 0.25s all ease;
    font-size: 12px;
}

/* DESPLEGABLE DE AÑO (NO SCROLLED) - Color Estable (Negro con Letras Blancas) */
.custom-select-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    list-style: none;
    padding: 0;
    margin: 1px 0 0 0;
    border-radius: 0 0 5px 5px;
    background-color: transparent !important;
    z-index: 2000;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
}

.custom-select-dropdown li {
    padding: 8px 10px;
    color: white !important;
    background-color: transparent !important;
    cursor: pointer;
    transition: background-color 0.1s;
}

.custom-select-dropdown li:hover {
    background-color: #041c2e;
}


/* ================================================= */
/* 2. ESTADO SCROLLED (Header Negro/Oscuro) */
/* ================================================= */

.booker-container.booker-scrolled {
    background-color: #fff;
    box-shadow: none;
    border-radius: 0;
}

/* ESTILOS SCROLLED para SELECTORES NATIVOS (<select>) */
.select select.select-scrolled {
    color: #06283c !important;
    background-color: white !important;
    border: 1px solid #06283c !important;
}

/* ESTILOS SCROLLED para el SELECTOR CUSTOMIZADO (AÑO) - Campo de Entrada */
.custom-select-wrapper.select-scrolled {
    color: #06283c !important;
    background-color: white !important;
    border: 1px solid #06283c !important;
}

/* Flecha del Select Nativo en estado SCROLLED */
.booker-container.booker-scrolled .select::after {
    color: #06283c !important;
}

/* Flecha del Custom Select en estado SCROLLED */
.arrow-scrolled {
    color: #06283c !important;
}

/* NUEVOS ESTILOS: DESPLEGABLE DE AÑO (SCROLLED) - Background Transparente/Claro */
.custom-select-dropdown.dropdown-scrolled {
    /* Fondo Claro/Transparente */
    background-color: white !important;
    border: 1px solid #06283c !important;
}

.custom-select-dropdown.dropdown-scrolled li {
    color: #06283c !important;
    /* Letras Oscuras */
    background-color: white !important;
    /* Fondo Blanco */
}

.custom-select-dropdown.dropdown-scrolled li:hover {
    background-color: #f0f0f0 !important;
    /* Gris Claro al hacer hover */
}

/* El spinner y el botón se ajustan */
.booker-container.booker-scrolled .spinner-border {
    color: white !important;
}
</style>